export function createProductionRequestGate({
  createController = () => new AbortController(),
} = {}) {
  let currentId = 0;
  let controller = null;

  return {
    begin() {
      controller?.abort();
      controller = createController();
      const id = ++currentId;
      return {
        id,
        signal: controller.signal,
        isCurrent: () => id === currentId,
        finish: () => {
          if (id === currentId) controller = null;
        },
      };
    },
    cancel() {
      controller?.abort();
      controller = null;
      currentId += 1;
    },
  };
}
